export function checkIsChatBot({settings, isAvailableTime, isPreviewAI}) {
  if (isPreviewAI) return true;
  const {isEnableAIAssistant, aiAssistantSettings} = settings;
  return (
    isEnableAIAssistant &&
    (aiAssistantSettings.aiAssistantMode !== 'only-offline' || !isAvailableTime)
  );
}
